import { AirbrushEffect } from './AirbrushEffect';

export class EraseCompare {
  /**
   * @param {HTMLElement} parent - Container element for the compare widget
   * @param {Object} options - Configuration options
   * @param {string} options.imageUrl - URL of the image
   * @param {number} [options.eraserSize=50] - Size of the eraser in pixels
   */
  constructor(parent, options = {}) {
    this.parent = parent;
    this.imageUrl = options.imageUrl;
    this.eraserSize = options.eraserSize || 50;
    this.cursorClass = options.cursorClass || 'cursor';
    this.isDrawing = false;

    this.init();
  }

  async init() {
    // Create canvas and add to parent
    this.canvas = document.createElement('canvas');
    this.ctx = this.canvas.getContext('2d');
    this.parent.appendChild(this.canvas);

    // Create cursor and add to parent
    this.cursor = document.createElement('div');
    this.cursor.className = this.cursorClass;
    this.parent.appendChild(this.cursor);
    this.cursorEffect = new AirbrushEffect(this.cursor, 100);

    // Initialize container states
    this.parent.classList.remove('is-mouse-inside', 'is-mouse-pressed');

    // Load image
    const img = await this.loadImage(this.imageUrl);

    // Set canvas dimensions
    this.resizeCanvas();
    window.addEventListener('resize', () => this.resizeCanvas());

    // Draw initial state
    this.drawImages(img);

    // Setup event listeners
    this.setupEvents();
  }

  loadImage(url) {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.src = url;
    });
  }

  resizeCanvas() {
    const { width, height } = this.parent.getBoundingClientRect();
    this.canvas.width = width;
    this.canvas.height = height;
  }

  drawImages(img) {
    const { width, height } = this.canvas;
    this.ctx.globalCompositeOperation = 'source-over';
    this.ctx.drawImage(img, 0, 0, width, height);
  }

  setupEvents() {
    this.canvas.addEventListener('mouseenter', () => {
      this.isDrawing = true;
      this.parent.classList.add('is-mouse-inside');
      this.cursorEffect.start();
    });

    this.canvas.addEventListener('mouseleave', () => {
      this.isDrawing = false;
      this.parent.classList.remove('is-mouse-inside', 'is-mouse-pressed');
      this.cursorEffect.stop();
    });

    this.canvas.addEventListener('mousedown', () => {
      //this.isDrawing = true;
      this.parent.classList.add('is-mouse-pressed');
    });

    this.canvas.addEventListener('mouseup', () => {
      //this.isDrawing = false;
      this.parent.classList.remove('is-mouse-pressed');
    });

    this.canvas.addEventListener('mousemove', (e) => {
      const rect = this.canvas.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      // Update position custom properties
      this.parent.style.setProperty('--mouse-x', `${x}px`);
      this.parent.style.setProperty('--mouse-y', `${y}px`);

      if (!this.isDrawing) return;

      // Erase the top image at cursor position
      this.ctx.globalCompositeOperation = 'destination-out';
      this.ctx.beginPath();
      this.ctx.arc(x, y, this.eraserSize / 2, 0, Math.PI * 2);
      this.ctx.fill();
    });
  }
}
